<template>
  <div>
    <v-container class="content-wrapper" fluid id="patents-tab">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Patents
          </h2>
        </v-col>
      </v-row>

      <v-row justify="center" align="center">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <TablePatents
              :search="search"
              :url-api="'/api/v1/patent/provider'"
              :search-attributes="['text']"
            ></TablePatents>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import TablePatents from './TablePatents.vue';

export default {
  name: 'Patents',
  components: { TablePatents },
  data: () => ({
    search: {},
  }),
};
</script>
